import PropTypes from "prop-types";
import React from "react";
import styles from "./email-form.module.scss";

function Step({ index, title, optional }) {
  return (
    <div className={styles["step-container"]}>
      <div className={styles["step-item"]}>{index}</div>
      <h3 className={styles["step-label"]}>
        {title}
        {optional ? <span>(Optional)</span> : null}
      </h3>
    </div>
  );
}

Step.defaultProps = {
  optional: false,
};

Step.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  optional: PropTypes.bool,
};

export default Step;
